"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLatestMixerBuildUrl = exports.getLatestBridgeBuildUrl = exports.prettyDate = exports.calculateRemainingTime = exports.customProtocolDetection = exports.isActiveSubscriberNoTrial = exports.isActiveSubscriber = exports.detectMobileAndTablet = exports.bridgeBuilds = exports.isClosed = exports.isOpen = exports.getMetaProp = exports.getMeshType = exports.isAssembly = exports.isScatter = exports.getLatestVersion = exports.cleanObj = exports.mapAndJoinStyles = exports.prettyPhysicalSize = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _toArray2 = require("babel-runtime/helpers/toArray");

var _toArray3 = _interopRequireDefault(_toArray2);

exports.getFormBaseUrl = getFormBaseUrl;
exports.getEviormentType = getEviormentType;
exports.detectOperatingSystem = detectOperatingSystem;
exports.extractHostname = extractHostname;
exports.checkWhiteListURL = checkWhiteListURL;
exports.relativeToSrc = relativeToSrc;
exports.getS3Url = getS3Url;
exports.getCloudfrontUrl = getCloudfrontUrl;
exports.getAlgoliaIndex = getAlgoliaIndex;
exports.getResolutionShortform = getResolutionShortform;
exports.getResolutionXRepresentation = getResolutionXRepresentation;
exports.getResolutionXRepresentationFromAsset = getResolutionXRepresentationFromAsset;
exports.getBitDepthFromMimeType = getBitDepthFromMimeType;
exports.getFileTypeFromMimeType = getFileTypeFromMimeType;
exports.getAssetResolutionsV2 = getAssetResolutionsV2;
exports.getAssetResolutions = getAssetResolutions;
exports.getMaxLOD = getMaxLOD;
exports.getMaxAssetResolution = getMaxAssetResolution;
exports.getComponentMimetypes = getComponentMimetypes;
exports.getAssetPhysicalSize = getAssetPhysicalSize;
exports.getAssetType = getAssetType;
exports.getAssetTypeThumbnail = getAssetTypeThumbnail;
exports.isRetina = isRetina;
exports.downloadAsset = downloadAsset;
exports.downloadLicenseFile = downloadLicenseFile;
exports.downloadBridgeLicenseFile = downloadBridgeLicenseFile;
exports.numberWithCommas = numberWithCommas;
exports.pluralize = pluralize;
exports.getScreenSize = getScreenSize;
exports.getDevicePixelRatio = getDevicePixelRatio;
exports.parseResolution = parseResolution;
exports.filterPreviewsWithTags = filterPreviewsWithTags;
exports.pickPreviewsForAsset = pickPreviewsForAsset;
exports.pickPreview = pickPreview;
exports.pickPreviewObj = pickPreviewObj;
exports.pickThumbUri = pickThumbUri;
exports.centsToDollars = centsToDollars;
exports.prettyVersion = prettyVersion;
exports.prettyDollars = prettyDollars;
exports.getSubscriptionPlans = getSubscriptionPlans;
exports.getPlanToResolution = getPlanToResolution;
exports.isEUCountry = isEUCountry;
exports.getCountryList = getCountryList;
exports.getCountryCode = getCountryCode;
exports.getCountryName = getCountryName;
exports.getNameFromCategories = getNameFromCategories;
exports.getAssetNameType = getAssetNameType;
exports.getAssetName = getAssetName;
exports.capitalize = capitalize;
exports.UUIDv4 = UUIDv4;

var _quixelBusinessCountries = require("@quixeltools/quixel-business-countries");

var _quixelBusinessCountries2 = _interopRequireDefault(_quixelBusinessCountries);

var _path = require("path");

var _path2 = _interopRequireDefault(_path);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _config = require("../config");

var _customProtocolDetection = require("./customProtocolDetection");

var _customProtocolDetection2 = _interopRequireDefault(_customProtocolDetection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pathToSrc = _path2.default.resolve(__dirname, ".");

var countries = _quixelBusinessCountries2.default;

var euCountries = ["AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "EL", "ES", "FI", "FR", "GB", "GR", "HR", "HU", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL", "PT", "RO", "SE", "SI", "SK", "UK"];

var importantCountries = ["US", "GB", "SE"];

function getFormBaseUrl() {
  return _config.forumBaseUrl;
}

function getEviormentType() {
  return _config.isProduction;
}

function detectOperatingSystem() {
  var OSName = "";

  if (typeof window !== "undefined") {
    if (navigator.appVersion.indexOf("Win") !== -1) OSName = "Windows";
    if (navigator.appVersion.indexOf("Mac") !== -1) OSName = "Mac";
    if (navigator.appVersion.indexOf("Linux") !== -1) OSName = "Linux";

    if (OSName.length <= 0) {
      if (navigator.platform.indexOf("Win") !== -1) OSName = "Windows";
      if (navigator.platform.indexOf("Mac") !== -1) OSName = "Mac";
      if (navigator.platform.indexOf("Linux") !== -1) OSName = "Linux";
    }
  }

  return OSName;
}

function extractHostname(url) {
  var _ref = new URL(url),
      hostname = _ref.hostname;

  return hostname;
}
function checkWhiteListURL(listOfUrl, urlToCompare) {
  var parseUrl = extractHostname(urlToCompare);

  return listOfUrl.filter(function (url) {
    return url === parseUrl;
  }).length > 0;
}
function relativeToSrc(value) {
  return value.slice(pathToSrc.length);
}

function getS3Url(path) {
  return "https://s3-us-west-2.amazonaws.com/" + path;
}

function getCloudfrontUrl(path) {
  var _path$split = path.split("/"),
      _path$split2 = (0, _toArray3.default)(_path$split),
      drop = _path$split2[0],
      bucket = _path$split2[1],
      objectPieces = _path$split2.slice(2);

  var object = objectPieces.join("/");

  return _config.assetsCloudFrontUrl + "/" + object;
}

function getAlgoliaIndex() {
  return _config.algoliaIndex;
}

function getResolutionShortform(resolutionString) {
  if (!resolutionString.match) return;

  var regex = /(\d+)x(\d+)/;
  var pieces = resolutionString.match(regex);

  if (pieces) {
    var width = parseInt(pieces[1]);
    var height = parseInt(pieces[2]);

    return width && height ? ~~(Math.max(width, height) / 1e3) + "K" : "";
  }
}

function getResolutionXRepresentation(numericRepresentation) {
  return numericRepresentation + "x" + numericRepresentation;
}

function getResolutionXRepresentationFromAsset(numericRepresentation, asset) {
  if (asset.categories[0] === "3dplant" || asset.categories[0] === "3d") {
    return getResolutionXRepresentation(numericRepresentation);
  }

  var resolutions = getAssetResolutions(asset);

  var targetResolution = resolutions.find(function (resolution) {
    var res = parseResolution(resolution);
    if (numericRepresentation === Math.max.apply(Math, (0, _toConsumableArray3.default)(res))) {
      return true;
    }
  });

  if (!_underscore2.default.isEmpty(targetResolution)) {
    return targetResolution;
  }

  return getResolutionXRepresentation(numericRepresentation);
}

function getBitDepthFromMimeType(mimeType) {
  var association = {
    "image/jpeg": 8,
    "image/png": 16,
    "image/x-exr": 16
  };

  return association[mimeType];
}

function getFileTypeFromMimeType(mimeType) {
  var association = {
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/x-exr": "exr",
    "image/tif": "tif"
  };

  return association[mimeType];
}

function getAssetResolutionsV2(asset) {
  var resolutions = _underscore2.default.uniq(_underscore2.default.pluck(asset.maps, "resolution"));
  console.log("resolutionsV2", resolutions);
  return resolutions;
}

function getAssetResolutions(asset) {
  var resolutions = [];
  asset.components && asset.components[0].uris && asset.components[0].uris[0].resolutions.map(function (res) {
    resolutions.push(res.resolution);
  });

  if (!resolutions.length) {
    resolutions = getAssetResolutionsV2(asset);
  }

  return resolutions;
}

function getMaxLOD(asset) {
  var type = asset.categories[0];

  var getMaxLODVersion1 = function getMaxLODVersion1(ass) {
    return ass.meshes.filter(function (mesh) {
      return mesh.type === "lod";
    }).length - 1;
  };
  var getMaxLODVersion2 = function getMaxLODVersion2(ass) {
    return Math.max.apply(Math, (0, _toConsumableArray3.default)(_underscore2.default.uniq(_underscore2.default.pluck(ass.models.filter(function (a) {
      return a.type === "lod";
    }), "lod"))));
  };

  var maxLod = type.startsWith("3d") && asset.version === 2 ? getMaxLODVersion2(asset) : type === "3d" && asset.version !== 2 ? getMaxLODVersion1(asset) : 0;

  return maxLod;
}

function getMaxAssetResolution(asset) {
  var getMax = function getMax(arr) {
    return _ramda2.default.max(_ramda2.default.nth(0, arr), _ramda2.default.nth(1, arr));
  };

  var getMaxResolutionPlant = function getMaxResolutionPlant(ass) {
    return Math.abs(Math.max.apply(Math, (0, _toConsumableArray3.default)(_underscore2.default.uniq(_underscore2.default.pluck(ass.maps, "resolution").map(function (res) {
      return Math.max.apply(Math, (0, _toConsumableArray3.default)(parseResolution(res)));
    })))));
  };

  var maxAssetResolution = asset.version === 2 ? getMaxResolutionPlant(asset) : _ramda2.default.compose(Math.abs, // to avoid weird -Infinity case with Math.max([])
  _ramda2.default.apply(Math.max), _ramda2.default.map(_ramda2.default.compose(getMax, parseResolution)), getAssetResolutions)(asset);

  return maxAssetResolution;
}

function getComponentMimetypes(component) {
  return _underscore2.default.uniq(_underscore2.default.pluck(component.uris[0].resolutions[0].formats, "mimeType"));
}

function getAssetPhysicalSize(asset) {
  return asset.components[0].uris[0].physicalSize;
}

var prettyPhysicalSize = exports.prettyPhysicalSize = _ramda2.default.compose(_ramda2.default.join("x"), _ramda2.default.map(_ramda2.default.compose(Math.ceil, parseFloat)), _ramda2.default.split("x"));

function getAssetType(asset) {
  return asset.categories[0];
}

function getAssetTypeThumbnail(type) {
  return "/images/asset-types/" + type + ".jpg";
}

var isRetinaCache = void 0;
function isRetina() {
  return false;

  if (__SERVER__) return false;

  if (isRetinaCache) return isRetinaCache;

  return isRetinaCache = Modernizr.mq("(-webkit-min-device-pixel-ratio: 1.5), (min-resolution: 144dpx)");
}

function downloadAsset(assetDownloadId, free) {
  var base = free ? _config.freeDownloaderBaseUrl : _config.paidDownloaderBaseUrl;
  var apiBase = _config.apiBaseUrl + "/v1/downloads";
  window.location = base + "/" + assetDownloadId + "?url=" + encodeURIComponent(apiBase) + "&preserveStructure=true";
}

function downloadLicenseFile(signature) {
  window.location = _config.apiBaseUrl + "/v1/payments/license/info/file?signature=" + signature;
}

function downloadBridgeLicenseFile(signature) {
  window.location = _config.apiBaseUrl + "/v1/payments/license/info/file/bridge?signature=" + signature;
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function pluralize(str) {
  if (str.toLowerCase() === "3d") return str;

  return str.endsWith("e") ? str + "s" : str + "es";
}

function getScreenSize() {
  var w = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName("body")[0],
      x = w.innerWidth || e.clientWidth || g.clientWidth,
      y = w.innerHeight || e.clientHeight || g.clientHeight;

  return {
    width: x,
    height: y
  };
}

function getDevicePixelRatio() {
  return window.devicePixelRatio || 1;
}

function parseResolution(resolution) {
  var _resolution$split = resolution.split("x"),
      _resolution$split2 = (0, _slicedToArray3.default)(_resolution$split, 2),
      width = _resolution$split2[0],
      height = _resolution$split2[1];

  return [parseInt(width), parseInt(height)];
}

function filterPreviewsWithTags(previews) {
  var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var excludeTags = arguments[2];

  var filteredPreviews = previews.filter(function (p) {
    return !p.tags || _underscore2.default.every([].concat(tags), function (t) {
      return _underscore2.default.contains(p.tags, t);
    });
  });
  if (excludeTags && excludeTags.length) {
    for (var i = 0; i < filteredPreviews.length; i++) {
      var preview = filteredPreviews[i];
      var containsExclude = false;
      for (var j = 0; j < preview.tags.length && !containsExclude; j++) {
        var atag = preview.tags[j];
        for (var k = 0; k < excludeTags.length && !containsExclude; k++) {
          var excludeTag = excludeTags[k];
          if (atag && atag.toLowerCase().indexOf(excludeTag) != -1) {
            containsExclude = true;
          }
        }
      }
      if (containsExclude) {
        filteredPreviews.splice(i, 1);
        i--;
      }
    }
  }
  return filteredPreviews;
}
var getSortedPreviews = function getSortedPreviews(previews, screenWidth, screenHeight) {
  var weights = previews.map(function (p) {
    return (0, _extends3.default)({}, p, {
      weight: Math.abs(Math.max.apply(Math, (0, _toConsumableArray3.default)(parseResolution(p.resolution))) - Math.max(+screenWidth, +screenHeight))
    });
  });
  var sortedMatches = !weights.length ? [] : weights.sort(function (a, b) {
    if (a.weight == b.weight) {
      var resolutionA = parseResolution(a.resolution);
      var resolutionB = parseResolution(b.resolution);

      return resolutionB[0] - resolutionA[0];
    } else {
      return a.weight - b.weight;
    }
  });
  return sortedMatches;
};
function pickPreviewsForAsset(assetType, screenWidth, screenHeight, previews) {
  var filteredPreviews = filterPreviewsWithTags(previews, ["preview", "jpeg"], ["lod", "cropped"]);
  if (!filteredPreviews || !filteredPreviews.length) {
    filteredPreviews = previews;
  }
  var sortedMatch = getSortedPreviews(filteredPreviews, screenWidth, screenHeight);

  var bestMatchResolution = sortedMatch[0].resolution;
  var finalPreviews = sortedMatch.filter(function (asset) {
    return asset.resolution == bestMatchResolution;
  });
  var retArray = []; //sortedMatch.filter(asset => asset.resolution == bestMatchResolution);
  var resolutions = []; //retArray.map((item, i) => (getCloudfrontUrl(item.resolution)));
  var nameArray = [];

  finalPreviews.map(function (item, i) {
    var previewTag = null;
    for (var j = 0; j < item.tags.length; j++) {
      var tag = item.tags[j];
      if (tag != "preview" && tag != "retina" && tag != "jpeg") {
        previewTag = tag;
        break;
      }
    }
    if (!previewTag) previewTag = "preview";
    if (previewTag === "preview") {
      retArray.unshift(getCloudfrontUrl(item.uri));
      nameArray.unshift(previewTag);
      resolutions.unshift(item.resolution);
    } else {
      retArray.push(getCloudfrontUrl(item.uri));
      nameArray.push(previewTag);
      resolutions.push(item.resolution);
    }
  });
  return { retArray: retArray, nameArray: nameArray, resolutions: resolutions };
}
function pickPreview(preferredResolution, previews, tags, excludeTags) {
  if (!excludeTags || excludeTags.length == 0) {
    excludeTags = [];
    var sholdAddLod = true;
    var sholdAddClay = true;
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].toLowerCase().indexOf("lod") != -1) {
        sholdAddLod = false;
      }
      if (tags[i].toLowerCase().indexOf("clay") != -1) {
        sholdAddClay = false;
      }
    }
    if (sholdAddLod) {
      excludeTags.push("lod");
    }
    if (sholdAddClay) {
      excludeTags.push("clay");
    }
  }

  var p = pickPreviewObj(preferredResolution, previews, tags, excludeTags);
  return p && p.uri;
}

function pickPreviewObj(preferredResolution, previews, tags, excludeTags) {
  var filtered = filterPreviewsWithTags(previews, tags, excludeTags);
  var weights = filtered.map(function (p) {
    return (0, _extends3.default)({}, p, {
      weight: Math.abs(Math.max.apply(Math, (0, _toConsumableArray3.default)(parseResolution(p.resolution))) - Math.max.apply(Math, (0, _toConsumableArray3.default)(parseResolution(preferredResolution)))),
      uri: p.uri
    });
  });
  if (!weights.length) return [];

  var sorted = !weights.length ? [] : weights.sort(function (a, b) {
    if (a.weight == b.weight) {
      var alen = a.tags.length;
      var blen = a.tags.length;
      return alen == blen ? a.contentLength - b.contentLength : alen - blen;
    }
    return a.weight - b.weight;
  });

  return sorted[0];
}

function pickThumbUri(previews) {
  var previewUri = pickPreview("24x24", previews);

  return previewUri.startsWith("data:image") ? previewUri : null;
}

function centsToDollars(cents) {
  return cents / 100;
}

function prettyVersion(version) {
  if (version.length != 5) return version;

  var ver = version.slice(0, 1);
  var major = version.slice(1, 3);
  var minor = version.slice(3, 5);

  return parseInt(ver) + "." + parseInt(major) + "." + parseInt(minor);
}

function prettyDollars(dollars) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return "$" + (decimals ? dollars.toFixed(2) : dollars);
}

function getSubscriptionPlans() {
  return [{
    type: "hobby",
    name: "Hobby",
    price: 19,
    points: 50,
    recursEvery: "m",
    resolution: "2K"
  }, {
    type: "freelancer",
    name: "Freelancer",
    price: 29,
    points: 80,
    recursEvery: "m",
    resolution: "2K"
  }, {
    type: "indie",
    name: "Indie",
    price: 1499,
    points: 1000,
    recursEvery: "y",
    resolution: "4K"
  }];
}

function getPlanToResolution() {
  return {
    hobby: 2048,
    freelancer: 4096,
    "freelancer-8K": 8192,
    "indie-team": 4096,
    "indie-team-8K": 8192,
    "indie-team-4K-100Plus": 4096,
    "indie-team-8K-100Plus": 8192,
    "studio-lite": 4096,
    studio: 8192,
    "private-beta": 2097152
  };
}

var mapAndJoinStyles = exports.mapAndJoinStyles = function mapAndJoinStyles(styles) {
  return function () {
    for (var _len = arguments.length, list = Array(_len), _key = 0; _key < _len; _key++) {
      list[_key] = arguments[_key];
    }

    return list.map(function (c) {
      return styles[c];
    }).join(" ");
  };
};

function isEUCountry(country) {
  return euCountries.indexOf(country) > -1;
}

function getCountryList() {
  return {
    important: importantCountries.map(function (code) {
      return countries.find(function (country) {
        return country.code == code;
      });
    }),
    rest: countries.filter(function (country) {
      return importantCountries.indexOf(country.code) == -1;
    })
  };
}

function getCountryCode(country) {
  var c = countries.find(function (c) {
    return c.name == country;
  });
  return c && c.code;
}

function getCountryName(code) {
  var c = countries.find(function (c) {
    return c.code == code;
  });
  return c && c.name;
}

function getNameFromCategories(categories) {
  var numberOfcategoriesToRead = Math.min(4, categories.length);

  var name = "";
  for (var i = 1; i < numberOfcategoriesToRead; i++) {
    name = name + " " + categories[i];
  }
  if (!name) {
    name = categories[0];
  }

  return name.trim();
}

function checkAssetForSubType(assetType, assetCategory, assetSubCategory, assetTags, assetName, subType) {
  if (assetType.indexOf(subType) != -1 || assetCategory.indexOf(subType) != -1 || assetSubCategory.indexOf(subType) != -1 || assetName.toLowerCase().indexOf(subType) != -1) {
    return true;
  }

  for (var i = 0; i < assetTags.length; i++) {
    if (assetTags[i].toLowerCase().indexOf(subType) != -1) {
      return true;
    }
  }
  return false;
}
function getAssetNameType(asset) {
  var assetType = asset.type;
  var assetCategory = asset.category;
  var assetSubCategory = asset.subCategory;
  var assetName = asset.name || "";
  var assetTags = asset.tags || asset._tags;

  if (!assetType && asset.categories) {
    assetType = asset.categories[0];
    assetCategory = asset.categories[1];
    assetSubCategory = asset.categories[2];
  }
  assetType = assetType || "";
  assetCategory = assetCategory || "";
  assetSubCategory = assetSubCategory || "";
  assetTags = assetTags || [];

  var type = assetType ? assetType.toLowerCase() : "";
  var typeColor = "#c44";

  if (checkAssetForSubType(assetType, assetCategory, assetSubCategory, assetTags, assetName, "imperfection")) {
    type = "imperfection";
    typeColor = "#904";
  } else if (checkAssetForSubType(assetType, assetCategory, assetSubCategory, assetTags, assetName, "metal")) {
    type = "metal";
    typeColor = "#777";
  } else if (checkAssetForSubType(assetType, assetCategory, assetSubCategory, assetTags, assetName, "displacement")) {
    type = "displacement";
    typeColor = "#298";
  } else if (checkAssetForSubType(assetType, assetCategory, assetSubCategory, assetTags, assetName, "decal")) {
    type = "decal";
    typeColor = "#aa0";
  } else if (checkAssetForSubType(assetType, assetCategory, assetSubCategory, assetTags, assetName, "fabric") || checkAssetForSubType(assetType, assetCategory, assetSubCategory, assetTags, assetName, "cloth")) {
    type = "fabric";
    typeColor = "#53a";
  }
  if (type == "3d") {
    if (isAssembly(asset) || checkAssetForSubType(assetType, assetCategory, assetSubCategory, assetTags, assetName, "assembly")) {
      type = "3D Assembly";
    }
    // else if(assetSubCategory){
    //   type = "3D " + capitalize(assetSubCategory);
    // }
    else {
        type = "3D Asset";
      }
    typeColor = "#c63";
  } else {
    // type = type == ('3dplant' || '3d plant') ? '3D Plant' : capitalize(type);
    type = type == "3dplant" || type == "3d plant" ? "3D Plant" : capitalize(type);
    typeColor = "#c63";
  }
  return {
    type: type,
    typeColor: typeColor,
    is3D: asset.type.toLowerCase().indexOf("3d") != -1
  };
}

function getAssetName(asset, truncate, removeType, assetType) {
  var name = asset.name ? asset.name.trim() : "";
  if (!name || !name.length || name == asset.id || name.length > 50) {
    name = getNameFromCategories(asset.categories);
  }
  name = name.toLowerCase();
  if (removeType && assetType && assetType.toLowerCase() != "brush") {
    var types = assetType.split(" ");
    for (var i = 0; i < types.length; i++) {
      var type = types[i];
      var index = name.indexOf(type);
      if (index != -1) {
        var endIndex = name.indexOf(" ", index);
        if (endIndex == -1) {
          endIndex = type.length;
        }
        name = name.slice(0, index) + name.slice(index + endIndex);
      }
    }
  }
  // if(truncate && name.length > 28){
  //     name = name.slice(0,25) + "...";
  // }
  return capitalize(name);
}

function capitalize(s) {
  return s.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function UUIDv4() {
  // https://gist.github.com/jed/982883
  function b(a) {
    return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, b);
  }

  return b();
}

var cleanObj = exports.cleanObj = _ramda2.default.ifElse(_ramda2.default.is(Object), _ramda2.default.converge(_ramda2.default.omit, [_ramda2.default.compose(_ramda2.default.keys, _ramda2.default.filter(_ramda2.default.isNil)), _ramda2.default.identity]), _ramda2.default.identity);

// Takes in bridge/studio feed and returns latest version based on platform
var getLatestVersion = exports.getLatestVersion = function getLatestVersion(arr, platform) {
  var latest = _underscore2.default.find(arr, function (a) {
    return platform.toLowerCase() === "windows" ? a.Url !== "" : a.UrlMac !== "";
  });

  return latest;
};

var isScatter = exports.isScatter = function isScatter(asset) {
  var is3d = asset.categories[0].toLowerCase() === "3d";
  return is3d && asset.categories && asset.categories.length > 1 && asset.categories[1] === "scatter";
};

var isAssembly = exports.isAssembly = function isAssembly(asset) {
  var is3d = asset.categories[0].toLowerCase() === "3d";

  return _underscore2.default.find(asset.meta, function (meta) {
    if (meta.key === "assembly") return is3d && meta.value.toLowerCase() === "true";
  });
};

var getMeshType = exports.getMeshType = function getMeshType(asset) {
  return _underscore2.default.find(asset.properties, function (prop) {
    return prop.key === "meshType" || prop.key === "mesh type";
  });
};

var getMetaProp = exports.getMetaProp = function getMetaProp(asset, prop) {
  var val = _underscore2.default.find(asset.meta, function (meta) {
    return meta.key === prop;
  });

  if (!_underscore2.default.isEmpty(val)) {
    return val.value;
  }
  return val;
};

var isOpen = exports.isOpen = function isOpen(asset) {
  var meshType = getMeshType(asset);
  var is3d = asset.categories[0].toLowerCase() === "3d";

  return is3d && meshType && meshType.value.toLowerCase() === "open";
};

var isClosed = exports.isClosed = function isClosed(asset) {
  var meshType = getMeshType(asset);
  var is3d = asset.categories[0].toLowerCase() === "3d";

  return is3d && meshType && meshType.value.toLowerCase() === "closed";
};

var bridgeBuilds = exports.bridgeBuilds = {
  windows: "https://d2shgxa8i058x8.cloudfront.net/bridge/win/Bridge.exe",
  mac: "https://d2shgxa8i058x8.cloudfront.net/bridge/mac/Bridge.dmg",
  linux: "https://d2shgxa8i058x8.cloudfront.net/bridge/linux/Bridge.AppImage"
};

var detectMobileAndTablet = exports.detectMobileAndTablet = function detectMobileAndTablet() {
  var check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

var isActiveSubscriber = exports.isActiveSubscriber = function isActiveSubscriber(user) {
  var subscription = user.subscription,
      megascansTrial = user.megascansTrial;


  var subscribed = subscription && subscription.isActive;
  if (!subscribed) {
    if (!_underscore2.default.isEmpty(megascansTrial)) {
      return megascansTrial.isActive;
    }
  }

  return subscribed;
};

var isActiveSubscriberNoTrial = exports.isActiveSubscriberNoTrial = function isActiveSubscriberNoTrial(user) {
  var subscription = user.subscription;

  var subscribed = subscription && subscription.isActive;
  return subscribed;
};

var customProtocolDetection = exports.customProtocolDetection = function customProtocolDetection() {
  (0, _customProtocolDetection2.default)();
};

var calculateRemainingTime = exports.calculateRemainingTime = function calculateRemainingTime(endDate, callback) {
  var diff = new Date(endDate).getTime() - new Date().getTime();
  var timeLeft = {
    years: 0,
    days: 0,
    hours: 0,
    min: 0,
    sec: 0
  };
  // clear countdown when date is reached
  if (diff <= 0) {
    if (callback) callback();
    return { timeLeft: timeLeft, diff: diff };
  }

  // calculate time difference between now and expected date
  //if (diff >= 86400) { // 24 * 60 * 60
  timeLeft.days = Math.floor(diff / (1000 * 60 * 60 * 24));
  //diff -= timeLeft.days * 86400;
  //}
  //if (diff >= 3600) { // 60 * 60
  timeLeft.hours = Math.floor(diff % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
  //diff -= timeLeft.hours * 3600;
  //}
  //if (diff >= 60) {
  timeLeft.min = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
  //diff -= timeLeft.min * 60;
  //}
  timeLeft.sec = Math.floor(diff % (1000 * 60) / 1000);

  return { timeLeft: timeLeft, diff: diff };
};

var prettyDate = exports.prettyDate = function prettyDate(dateString) {
  return new Date(dateString).toLocaleString("en-us", {
    month: "long",
    day: "numeric",
    year: "numeric"
  });
};

var getLatestBridgeBuildUrl = exports.getLatestBridgeBuildUrl = function getLatestBridgeBuildUrl() {
  var platform = detectOperatingSystem();
  var downloadUrl = bridgeBuilds[platform.toLowerCase()];
  var mailTo = encodeURI("mailto:?subject=Quixel Bridge Download Link&body=Note to self: Remember to download Quixel Bridge the next time I am on my desktop machine.\n\n      Here are the download links \u2014\n\n\n      Windows: " + bridgeBuilds.windows + "\n\n\n      Mac: " + bridgeBuilds.mac + "\n\n\n      Linux: " + bridgeBuilds.linux + "\n\n\n      ");

  if (__CLIENT__ && detectMobileAndTablet()) {
    downloadUrl = mailTo;
  }

  return downloadUrl;
};

var getLatestMixerBuildUrl = exports.getLatestMixerBuildUrl = function getLatestMixerBuildUrl() {
  return function (dispatch, getState) {
    var platform = detectOperatingSystem();

    var _getState = getState(),
        softwares = _getState.softwares;

    var mixerUpdater = softwares.mixerUpdater;

    var latest = getLatestVersion(mixerUpdater, platform);
    var mixerBuilds = {
      mac: latest ? latest.UrlMac : "",
      windows: latest ? latest.Url : "",
      linux: "/products/mixer"
    };
    var downloadUrl = mixerBuilds[platform.toLowerCase()];
    var mailTo = encodeURI("mailto:?subject=Quixel Mixer Download Link&body=Note to self: Remember to download Quixel Mixer the next time I am on my desktop machine.\n\n      Here are the download links \u2014\n\n\n      Windows: " + mixerBuilds.windows + "\n\n\n      Mac: " + mixerBuilds.mac + "\n\n\n      Linux: " + mixerBuilds.linux + "\n\n\n      ");

    if (__CLIENT__ && detectMobileAndTablet()) {
      downloadUrl = mailTo;
    }

    return downloadUrl;
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/index.js
// module id = 21
// module chunks = 0